define('components/util/social-share',[
    'jquery',
    'components/util/tool-menu',
    'components/handlers/analytics'
],function(
    jQuery,
    toolMenu,
    analytics
){

    var appId = '7692650820';
    var instance;
    var link = document.createElement('a');
    var windowCloser = 'https://fd.nl/#close_window';
    var source = 'Company.Info';
    var protocol = location.protocol;

    function SocialSharing(){
        this.init();
    }

    SocialSharing.prototype = {

        //hasWhatsappSupport: ((navigator.userAgent.match(/Android|iPhone/i) && !navigator.userAgent.match(/iPod|iPad/i)) ? true : false),

        popup: null,

        init: function(){
            jQuery(document).on('click','.share-social'     ,jQuery.proxy(this.toggleTooltip,this));
            jQuery(document).on('click','.share-facebook,.share-twitter,.share-linkedin'   ,jQuery.proxy(this.share,this));
        },

        toggleTooltip: function( element ){
            toolMenu.show( this.getContent( element ), element );
        },

        getContent: function( shareNode ){
            var title = shareNode.getAttribute('data-title')||'';
            var url = this.getAbsoluteUrl( shareNode.getAttribute('data-url') )||'';
            var intro = shareNode.getAttribute('data-intro')||'';
            var readOn = shareNode.getAttribute('data-read-on'||'');
            var sharedBy = shareNode.getAttribute('data-shared-by'||'');
            var excluded = (shareNode.getAttribute('data-exclude') || '').split(/\s+/);

            var eTitle = encodeURIComponent('\'' + title + '\' | ' + sharedBy);
            var eIntro = encodeURIComponent(readOn + url);
            var emailUrl = 'mailto:?subject='+eTitle+'&body='+eIntro;
            var whatsappText = encodeURIComponent('\'' + title + '\'\n' + url);

            var content = ['<span class="title">'+companyInfo.labels.shareWith+'</span>'];

            if ( excluded.indexOf('twitter') < 0) {
                content.push('<button class="inline-button share-twitter" data-url="',url,'" data-title="',title,'" data-intro="',intro,'"><i class="ico ico-twitter"></i>Twitter</button>');
            }
            if ( excluded.indexOf('linkedin') < 0) {
                content.push('<button class="inline-button share-linkedin" data-url="', url, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-linkedin"></i>LinkedIn</button>');
            }
            if ( excluded.indexOf('facebook') < 0) {
                content.push('<button class="inline-button share-facebook" data-url="', url, '" data-title="', title, '" data-intro="', intro, '"><i class="ico ico-facebook"></i>Facebook</button>');
            }
            //if(this.hasWhatsappSupport) {
            //    content.push('<a class="share-whatsapp" href="whatsapp://send?text='+whatsappText+'" data-text="', title, '" data-href="', url, '">WhatsApp</a>');
            //}
            if ( excluded.indexOf('mail') < 0) {
                content.push('<a class="share-email" data-handler="analytics" data-analytics-params="articles,Email share,'+title+'" href="', emailUrl, '"><i class="ico ico-envelope"></i>E-mail</a>');
            }

            content = content.join('');

            return content;
        },

        getAbsoluteUrl: function( url ){
            link.href = url;
            return link.href;
        },

        share: function( event ){
            this.open( this.getWindowUrl( event.target ) );
        },

        getWindowUrl: function( shareNode ){

            var title = shareNode.getAttribute('data-title')||'';
            var url = shareNode.getAttribute('data-url')||'';
            var intro = shareNode.getAttribute('data-intro')||'';
            var eTitle = encodeURIComponent(title);
            var eUrl = encodeURIComponent(url);
            var eIntro = encodeURIComponent(intro);
            var mode = shareNode.getAttribute('data-social-mode') || 'share';
            var className = shareNode.className;

            if ( className.indexOf('share-facebook') > -1 ) {
                analytics(['articles','Facebook share',title]);
                if ( mode == 'message' ) {
                    return 'https://www.facebook.com/dialog/feed?redirect_uri=' + encodeURIComponent(windowCloser) + '&display=popup&app_id='+appId+'&description='+eIntro+'&link='+eUrl+'&name='+eTitle;
                } else {
                    return 'http://www.facebook.com/dialog/share?app_id='+appId+'&display=popup&href='+eUrl+'&redirect_uri='+encodeURIComponent(windowCloser);
                }
            } else if ( className.indexOf('share-twitter') > -1 ) {
                analytics(['articles','Twitter share',title]);
                if (mode=='message') {
                    return 'https://twitter.com/intent/tweet?text='+encodeURIComponent(this.createTwitterMessage(intro,url));
                } else {
                    return 'https://twitter.com/intent/tweet?text='+encodeURIComponent(this.createTwitterMessage(title,url));
                }
            } else if ( className.indexOf('share-linkedin') > -1 ) {
                analytics(['articles','LinkedIn share',title]);
                return 'http://www.linkedin.com/shareArticle?mini=true&url='+eUrl+'&title='+eTitle+'&summary='+eIntro+'&source=' + source;
            }

        },

        /**
         * Builds a tweet ensuring it does not exceed the char length of 140.
         *
         * For URLs we maintain a fixed size of 27 due to twitter URL shortening.
         * Twitter will use the shortened URL length to determine the chars spent rather than the actual URL length inserted.
         * At the time (26-11-2014) of adding this, the spent url size (shortened url) is 22 for http and 23 for https, we added 5 to
         * that number to be certain this fix will last for quite a while.
         *
         * @param {string} title
         * @param {string} url
         * @returns {string}
         */
        createTwitterMessage: function( title, url ){
            var message = ' ' + url + ' #CompanyInfo';
            // 140 - ('  #CompanyInfo'.length + 27) = charsLeft
            // AND subtract 1 extra for the period we always add.
            var charsLeft = 100;
            if ( title.length >= charsLeft ) {
                title = title.substring(0,charsLeft - 2);
                title = title + '..';
            }
            title = title + '.';

            message = title + message;
            return message;
        },

        open: function( url ){
            if ( this.popup && 'close' in this.popup ) {
                this.popup.close();
            }
            this.popup = window.open(url,'company_info','width=850,height=600,resizable=1,scrollbars=1');
            this.popup.moveTo(
                ( window.screen.width - 850 ) / 2,
                ( window.screen.height - 600 ) / 2
            );
        }

    };

    return {
        getInstance: function(){
            return instance || ( instance = new SocialSharing() );
        }
    };

});

